import {
  IntlProvider as IntlProviderBase,
  load,
} from '@progress/kendo-react-intl'
import currencyData from 'cldr-core/supplemental/currencyData.json'
import likelySubtags from 'cldr-core/supplemental/likelySubtags.json'
import weekData from 'cldr-core/supplemental/weekData.json'
import jaCaGregorian from 'cldr-dates-full/main/ja/ca-gregorian.json'
import jaDateFields from 'cldr-dates-full/main/ja/dateFields.json'
import jaLocalCurrency from 'cldr-numbers-full/main/ja/currencies.json'
import jaNumbers from 'cldr-numbers-full/main/ja/numbers.json'
import React from 'react'
import { useMount } from 'react-use'

export type IntlProviderProps = React.PropsWithChildren<{
  language: string
}>

export const IntlProvider = ({ children, language }: IntlProviderProps) => {
  useMount(() => {
    load(
      likelySubtags,
      currencyData,
      weekData,
      jaNumbers,
      jaLocalCurrency,
      jaCaGregorian,
      jaDateFields,
    )
  })

  return <IntlProviderBase locale={language}>{children}</IntlProviderBase>
}
